export const RECORD_LABELS = {
  activity: '活動',
  replace: '移転',
  norm:     'ノルマ',
  penalty:  'ペナルティ'
};
